function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M383.973 65.3872L222.941 134.601L246.145 198.592L262.729 244.319L266.898 255.819L304.006 269.904L305.348 270.413L344.111 285.12L362.719 277.162L388.068 266.266L400 261.137L383.973 65.3872Z",
  fill: "#DDDDDD",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.193 259.678L388.16 261.337L388.068 266.266L362.719 277.162L345.6 284.519L344.878 282.105L344.111 285.12L305.348 270.413L304.747 256.213V256.21L304.615 253.054L380.552 247.957L382.041 250.238L382.336 250.692L388.193 259.678Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.155 108.828C333.155 108.828 328.058 127.174 327.039 127.174C326.02 127.174 336.722 141.444 336.722 141.444L352.521 150.108L358.127 126.665C358.127 126.665 353.03 113.924 354.05 107.299L333.155 108.828Z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.309 115.963C351.723 115.963 360.165 107.52 360.165 97.1061C360.165 86.692 351.723 78.2496 341.309 78.2496C330.895 78.2496 322.452 86.692 322.452 97.1061C322.452 107.52 330.895 115.963 341.309 115.963Z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.857 136.348L328.791 123.264L319.904 127.684L300.538 139.915C300.538 139.915 305.634 249.996 303.086 254.073C303.086 254.073 308.692 266.814 341.818 259.17C374.945 251.525 383.608 250.506 383.608 250.506L376.473 183.234L385.137 140.935L356.036 120.584L346.915 136.348L343.857 136.348Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.797 179.157C287.797 179.157 280.153 203.11 285.759 205.658C291.364 208.206 295.951 207.187 295.951 207.187L304.615 186.292L287.797 179.157Z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M393.801 175.08L398.388 196.485V239.804C398.388 239.804 391.763 267.324 386.666 260.189C381.57 253.054 381.675 250.795 381.675 250.795L388.195 240.823L385.137 200.052L377.012 180.603L393.801 175.08Z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.146 78.2496C359.146 78.2496 353.03 64.9991 341.309 68.0569C329.587 71.1147 322.962 75.7014 322.452 80.2881C321.943 84.8748 322.707 91.7549 322.707 91.7549C322.707 91.7549 323.981 82.3267 332.135 84.3652C340.289 86.4037 353.03 84.8748 353.03 84.8748L355.069 103.222C355.069 103.222 357.362 99.909 359.91 101.948C362.459 103.986 367.3 82.3266 359.146 78.2496Z",
  fill: "#2E4137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.146 179.288L378.989 188.872L397.051 184.08L393.734 175.233L377.146 179.288Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.462 178.988L284.582 188.313L302.776 192.576L304.008 183.208L287.462 178.988Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M373.416 139.915L385.137 140.935C385.137 140.935 398.388 177.119 396.859 178.138C395.33 179.157 376.983 185.273 374.435 183.744C371.887 182.215 373.416 139.915 373.416 139.915Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.615 140.935L300.538 139.915C300.538 139.915 292.893 149.598 290.345 160.81C287.797 172.022 284.23 183.234 286.268 183.234C288.307 183.234 306.654 190.369 306.654 190.369L304.615 140.935Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.814 143.533C347.85 143.533 349.5 141.882 349.5 139.847C349.5 137.811 347.85 136.161 345.814 136.161C343.778 136.161 342.128 137.811 342.128 139.847C342.128 141.882 343.778 143.533 345.814 143.533Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.273 205.02L334.899 217.433L318.829 166.457C334.001 164.33 347.126 160.192 358.203 154.045C360.257 171.433 365.503 188.438 374.273 205.02Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M370.587 210.549L331.213 222.962L315.143 171.987C330.315 169.859 343.44 165.721 354.517 159.574C356.571 176.962 361.817 193.967 370.587 210.549Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.345 190.879C290.345 190.879 284.23 202.091 285.759 205.658C287.287 209.226 300.028 211.264 301.557 211.264C303.086 211.264 321.433 207.187 321.433 207.187C321.433 207.187 349.463 193.937 341.309 187.311C333.155 180.686 317.866 196.485 317.866 196.485H305.634L299.009 191.898L290.345 190.879Z",
  fill: "#FFB8B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.9513 46.0573H0.341553V75.8326H66.9513V46.0573Z",
  fill: "#E2E2E2",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.528 142.784H230.914V153.032H242.528V142.784Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.3 142.784H207.686V153.032H219.3V142.784Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.756 120.239H254.142V131.853H265.756V120.239Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.142 131.853H242.528V142.784H254.142V131.853Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.914 131.853H219.3V142.784H230.914V131.853Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.2537 152.348H81.6396V162.596H93.2537V152.348Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.78 141.418H186.166V152.348H197.78V141.418Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.096 141.418H116.482V152.348H128.096V141.418Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.482 129.804H104.868V141.418H116.482V129.804Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.552 141.418H162.938V152.348H174.552V141.418Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.938 129.804H151.324V141.418H162.938V129.804Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.324 141.418H139.71V152.348H151.324V141.418Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.868 141.418H93.2537V152.348H104.868V141.418Z",
  fill: "#6E8580"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.166 129.804H174.552V141.418H186.166V129.804Z",
  fill: "#16A085"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.068 111.868L221.034 105.4L227.503 99.3657L233.537 105.835L227.068 111.868ZM221.996 105.433L227.101 110.907L232.575 105.801L227.47 100.327L221.996 105.433Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.401 85.2548H136.554V76.4087H145.401V85.2548ZM137.235 84.5743H144.72V77.0892H137.235V84.5743Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.705 68.1753H300.858V59.3292H309.705V68.1753ZM301.539 67.4949H309.024V60.0097H301.539V67.4949Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.9108 158.52L86.388 158.01C88.7925 155.283 90.6152 152.095 91.7442 148.639C93.5217 143.29 94.39 134.842 88.4316 124.973C82.3353 114.876 82.061 106.675 82.9042 101.573C83.8219 96.022 86.1631 92.9103 86.2622 92.7806L86.8429 93.2243C86.8195 93.2548 84.4987 96.3499 83.618 101.736C82.805 106.708 83.0886 114.71 89.057 124.596C95.1677 134.717 94.2625 143.399 92.4272 148.901C90.4385 154.862 87.054 158.374 86.9108 158.52Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.14 135.292L178.617 134.782C181.021 132.056 182.844 128.867 183.973 125.411C185.75 120.062 186.619 111.614 180.66 101.745C174.564 91.6484 174.29 83.4473 175.133 78.3455C176.051 72.7941 178.392 69.6824 178.491 69.5527L179.072 69.9964C179.048 70.0269 176.727 73.122 175.847 78.5078C175.034 83.4802 175.317 91.4826 181.286 101.368C187.396 111.489 186.491 120.171 184.656 125.673C182.667 131.634 179.283 135.146 179.14 135.292Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.413 126.411L258.89 125.901C261.295 123.174 263.117 119.986 264.246 116.53C266.024 111.181 266.892 102.733 260.934 92.8641C254.837 82.7671 254.563 74.566 255.406 69.4641C256.324 63.9128 258.665 60.8011 258.764 60.6714L259.345 61.115C259.322 61.1455 257.001 64.2406 256.12 69.6265C255.307 74.5988 255.591 82.6012 261.559 92.4863C267.67 102.607 266.765 111.29 264.929 116.792C262.941 122.752 259.556 126.264 259.413 126.411Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.72 55.4558H17.5728V56.1864H49.72V55.4558Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.72 60.5796H17.5728V61.3102H49.72V60.5796Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.72 65.7035H17.5728V66.4341H49.72V65.7035Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.737 6.60864H197.59V7.33926H229.737V6.60864Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.737 11.7325H197.59V12.4632H229.737V11.7325Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.737 16.8563H197.59V17.5869H229.737V16.8563Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.228 120.016H273.081V120.747H305.228V120.016Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.228 125.14H273.081V125.87H305.228V125.14Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.228 130.264H273.081V130.994H305.228V130.264Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.349 171.254H71.2021V171.985H103.349V171.254Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.349 176.378H71.2021V177.109H103.349V176.378Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.349 181.502H71.2021V182.232H103.349V181.502Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0916 37.7868C52.6457 25.3279 61.017 17.1324 71.9726 13.4277C80.1068 10.677 89.5137 10.417 99.9321 12.6548C107.615 14.3174 114.987 17.181 121.777 21.1401C157.945 42.1308 180.306 42.3174 192.695 38.7776C206.28 34.8966 211.251 25.7899 211.3 25.6983L211.903 26.0182C211.854 26.1121 206.769 35.4571 192.91 39.4269C184.92 41.7155 175.584 41.81 165.162 39.7078C152.192 37.0913 137.479 31.0431 121.434 21.7311C114.706 17.8081 107.401 14.9704 99.7889 13.3227C82.7015 9.65248 59.7966 10.9656 47.7153 38.065L47.0916 37.7868Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.4466 93.2537C94.2381 93.2537 99.7438 87.748 99.7438 80.9565C99.7438 74.1649 94.2381 68.6593 87.4466 68.6593C80.655 68.6593 75.1494 74.1649 75.1494 80.9565C75.1494 87.748 80.655 93.2537 87.4466 93.2537Z",
  fill: "#519386"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.359 71.7335C187.15 71.7335 192.656 66.2279 192.656 59.4363C192.656 52.6448 187.15 47.1392 180.359 47.1392C173.567 47.1392 168.062 52.6448 168.062 59.4363C168.062 66.2279 173.567 71.7335 180.359 71.7335Z",
  fill: "#519386"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.632 60.8027C267.423 60.8027 272.929 55.2971 272.929 48.5056C272.929 41.714 267.423 36.2084 260.632 36.2084C253.84 36.2084 248.335 41.714 248.335 48.5056C248.335 55.2971 253.84 60.8027 260.632 60.8027Z",
  fill: "#519386"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.1742 76.1742H0V37.2332H76.1742V76.1742ZM0.683177 75.491H75.491V37.9163H0.683177V75.491Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.938 20.4381H96.3279V50.2135H162.938V20.4381Z",
  fill: "#E2E2E2",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.706 29.8367H113.559V30.5673H145.706V29.8367Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.706 34.9606H113.559V35.6912H145.706V34.9606Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.682 39.0596H112.534V39.7902H144.682V39.0596Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.161 50.5551H95.9863V11.614H172.161V50.5551ZM96.6695 49.8719H171.477V12.2972H96.6695V49.8719Z",
  fill: "#AFAFAF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.757 8.8241H268.147V38.5995H334.757V8.8241Z",
  fill: "#E2E2E2",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.525 18.2227H285.378V18.9533H317.525V18.2227Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.525 23.3466H285.378V24.0772H317.525V23.3466Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.525 28.4703H285.378V29.201H317.525V28.4703Z",
  fill: "#A7A7A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.979 38.9411H267.805V0H343.979V38.9411ZM268.488 38.2579H343.296V0.683177H268.488V38.2579Z",
  fill: "#AFAFAF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 400,
  height: 285.12,
  fill: "white"
})));

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 286,
    viewBox: "0 0 400 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.8ec0a864.svg";
export { ForwardRef as ReactComponent };